import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/bombas/BombasSumergibles.png';
import Img2 from '../../img/products/bombas/BombasSumergibles/BombasSumergibles1.png';
import Img3 from '../../img/products/bombas/BombasSumergibles/BombasSumergibles2.png';
// import Img4 from '../../img/products/bombas/BombasSumergibles.png';

const BombasSumergibles = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-4">
      <h2 className="mb-4 text-center">Bombas Sumergibles para Pozo Profundo</h2>

      {/* Estilos inline o puedes mover esto a tu CSS */}
      <style>{`
        .img-hover-zoom {
          transition: transform 0.3s ease;
        }

        .img-hover-zoom:hover {
          transform: scale(1.05);
        }
      `}</style>

      <div className="row align-items-start mb-2">
        {/* Columna Izquierda: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas sumergibles para pozo profundo son dispositivos diseñados para extraer agua de pozos 
            profundos y otras fuentes subterráneas. Estas bombas son sumergidas directamente en el agua, lo 
            que permite una extracción eficiente y confiable. Estas bombas están diseñadas para operar 
            completamente sumergidas en el agua, lo que elimina la necesidad de cebado y reduce el riesgo de
            cavitación.
          </p>
          <p className="lead text-justify">
            Las bombas sumergibles para pozo profundo cuentan con múltiples impulsores que aumentan la presión
            del agua a medida que se eleva desde el fondo del pozo. Los motores están sellados herméticamente
            para evitarla entrada de agua y proteger los componentes eléctricos. Al estar sumergidas, estas 
            bombas no necesitan gastar energía en levantar el agua hasta la bomba, lo que mejora la eficiencia
            energética.
          </p>
          <p className="lead text-justify">
            Estas operan de manera silenciosa, lo que es ideal para aplicaciones residenciales y comerciales.
            Son adecuadas para una amplia gama de aplicaciones, incluyendo el suministro de agua potable, riego 
            agrícola, sistemas depresión y llenado de tanques elevados. La instalación de estas bombas es 
            relativamente sencilla y no requiere una infraestructura compleja. Gracias a su diseño robusto y 
            materiales de alta calidad, estas bombas requieren un mantenimiento mínimo y ofrecen una larga vida útil.
          </p>
        </div>
        {/* Columna derecha: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-4">
            <div className="col-5">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
            <div className="col-5">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 2" />
            </div>
            <div className="col-5">
              <img src={Img3} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 3" />
            </div>
            {/* <div className="col-6">
              <img src={Img4} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 4" />
            </div> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BombasSumergibles;
